import { render, staticRenderFns } from "./Filter-sidebar.vue?vue&type=template&id=5f318501&scoped=true&lang=pug"
import script from "./Filter-sidebar.vue?vue&type=script&lang=js"
export * from "./Filter-sidebar.vue?vue&type=script&lang=js"
import style0 from "./Filter-sidebar.vue?vue&type=style&index=0&id=5f318501&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f318501",
  null
  
)

export default component.exports